// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LocationSearchForm-viewCategoryHourlySearchHeading-ZKKRF {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    color: var(--primary-foreground);
    margin-bottom: 18px;
    text-align: start;
}

@media (max-width: 767px) {
    .LocationSearchForm-viewCategoryHourlySearchHeading-ZKKRF {
        font-size: 18px;
        line-height: 28px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ViewCategory/LocationSearchForm/LocationSearchForm.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".viewCategoryHourlySearchHeading {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 30px;\n    color: var(--primary-foreground);\n    margin-bottom: 18px;\n    text-align: start;\n}\n\n@media (max-width: 767px) {\n    .viewCategoryHourlySearchHeading {\n        font-size: 18px;\n        line-height: 28px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewCategoryHourlySearchHeading": `LocationSearchForm-viewCategoryHourlySearchHeading-ZKKRF`
};
module.exports = ___CSS_LOADER_EXPORT___;
